module.exports = __webpack_public_path__ + "static/media/img-02.a385d4e8.jpg";